import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from 'react-native-paper';
import { useThemeSettings } from '../../../ThemeProvider';
import { IStakeholderImpact } from '../types';
import { CustomIcon } from '../../../components/CustomIcon';
import { useTranslation } from 'react-i18next';
import { useActiveArticleStore } from '../../../store/activeArticleStore';

interface StakeholderImpactProps {
  content: IStakeholderImpact[];
  style?: object;
}
const colorMapping: any = {
  "hopeful": "#1E6685",
  "worried": "#E81212",
  "supportive": "#09671D",
  "opposed": "#FF7017",
  "neutral": "#7E7762",
  "uncertain": "#FFC415"
}

export const StakeholderImpact: React.FC<StakeholderImpactProps> = ({ content, style = {} }) => {
  const { theme } = useThemeSettings();
  const { t } = useTranslation();

  const { activeView} = useActiveArticleStore();
  return (
      <View style={{gap:16}}>
        {content.map((stakeholder, index) => (
          <View
            key={index}
            style={[
              styles.stakeholderCard,
              {elevation: (activeView.startsWith('RIPPLE_EFFECT') || activeView.startsWith('STORY_SO_FAR')) ? 2 : 0},
              { backgroundColor: theme?.colors?.btnBgFill }
            ]}
          >
            <Text style={{ color: theme?.colors?.secondary, fontSize: 18 }} >{stakeholder.title}  </Text>
            <Text
              style={{ color: theme?.colors?.bodyText }}
              variant="bodyMedium"
            >
              {stakeholder.description}
            </Text>
            {/* <View style={styles.impactSection}>
              <Text
                style={[styles.impactLabel, { color: colorMapping[stakeholder.sentiment] }]}
                variant="bodySmall"
              >
                {t(`screens.article.sentiment.${stakeholder.sentiment}`)}
              </Text>
              <CustomIcon size={16} icon={stakeholder.sentiment} />
            </View> */}
          </View>
        ))}
      </View>
  );
};

const styles = StyleSheet.create({
  stakeholderCard: {
    flexDirection: 'column',
    gap: 8,
    borderRadius: 12,
    padding: 20
  },
  impactSection: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  impactLabel: {
    fontStyle: 'italic',
    fontSize: 12,
    fontWeight: 500,
    // fontFamily: 'Poppins-Medium'
  },
});

export default StakeholderImpact;
